import i18n from "i18next";
import { getkey } from "@util/utils";
import {
  appendFallbackLngToUrl,
  SUPPORTED_CODES,
  normalizeCode,
} from "@util/langConfig";

const toSupportedCode = (value) => {
  const text = String(value || "").trim().toLowerCase();
  if (!text) return "";

  const candidates = [text, text.split(/[-_,]/)[0]];
  for (const candidate of candidates) {
    const code = normalizeCode(candidate);
    if (SUPPORTED_CODES.includes(code)) return code;
  }
  return "";
};

export const getCurrentLanguageCode = (language) => {
  let sessionLanguage = "";
  try {
    sessionLanguage = window.sessionStorage.getItem("lang");
  } catch (error) {
    sessionLanguage = "";
  }

  return (
    [
      language,
      i18n?.language,
      typeof window !== "undefined" ? window.lang : "",
      sessionLanguage,
      getkey("fallbackLng"),
    ]
      .map(toSupportedCode)
      .find(Boolean) || "zh"
  );
};

export const getFallbackLngParam = (language) =>
  `&fallbackLng=${encodeURIComponent(getCurrentLanguageCode(language))}`;

export const appendCurrentLanguageToUrl = (url, language) =>
  appendFallbackLngToUrl(url, getCurrentLanguageCode(language));
